import React, {useState} from 'react';

import aloneImg from './../media/oleg.html/one.jpg';
import togetherImg from './../media/oleg.html/two.jpg';

function Oleg() {

    const [showResult, setShowResult] = useState('');
    const [imageSrc, setImageSrc] = useState(aloneImg);
    const [noButton_pos, setNoButton_pos] = useState({x: 0, y: 0});
    const [isPressedYes, setIsPressedYes] = useState(false);

    const handleYesButton = () => {
        setShowResult('❤️ УРА!');
        setImageSrc(togetherImg);
        setIsPressedYes(true);
    };
    
    const handleNoButton = () => {
        const maxX = window.innerWidth - 100;
        const maxY = window.innerHeight - 40;

        const randomX = Math.floor(Math.random() * maxX);
    const randomY = Math.floor(Math.random() * maxY);

    setNoButton_pos({x: randomX, y: randomY});

    };

    return (
        <div style={{ textAlign: 'center', marginTop: '50px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Будешь моей валентинкой?</h1>

      <div className="buttons" style={{ position: 'relative', display: 'inline-block' }}>
        <button
          id="yesBtn"
          onClick={handleYesButton}
          style={{
            fontSize: '18px',
            padding: '10px 20px',
            margin: '10px',
            backgroundColor: '#ff69b4',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          Да
        </button>

        <button
          id="noBtn"
          onClick={handleNoButton}
          style={{
            fontSize: '18px',
            padding: '10px 20px',
            margin: '10px',
            backgroundColor: '#ff4d4d',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            position: 'absolute',
            left: `${noButton_pos.x}px`,
            top: `${noButton_pos.y}px`,
            transition: 'left 0.2s, top 0.2s'
          }}
        >
          Нет
        </button>

        {showResult && <div id="result" style={{ margin: '20px 0', fontSize: '24px' }}>{showResult}</div>}

        <br /><br /><br />
        <img
          id="photo"
          src={imageSrc}
          alt="No image :("
          style={{ width: '75%', height: 'auto', maxWidth: '800px' }}
        />
      </div>
    </div>
    );
}

export default Oleg;
